<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import axios from "axios";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
export default {
  page: {
    title: "Información de la cotizacion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      stock: [],
      url: 0,
      formPro: {
        user: "",
        fecha_venta: "",
        fecha_vencimiento: "",
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        observaciones: "",
        no_ducumento_v: "",
        sucursal: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        usuario : "",
        metodos: [],
        saldo: "",
        estado_saldo: false,
        estado_credito_v : false,
        estado_pagado_v : false,
        total_v: "",
        state: true,
        id: 0,
      },
      detalleProducto: [],
      detalleServicio: [],
      fields: [
        {
          name: "producto.nombre_producto",
          sortField: "producto.nombre_producto",
          title: "Nombre",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "producto.codigo_stock",
          sortField: "codigo",
          title: "Código",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "producto.marca.nombre_marca",
          sortField: "marcas",
          title: "Marca",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        
        {
          name: "cantidad_venta",
          sortField: "cantidad_venta",
          title: "Cantidad",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "precio_compra",
          sortField: "precio_compra",
          title: "Precio venta",
          titleClass: "",
          dataClass: "list-item-heading",
        },

        {
          name: "subtotal",
          sortField: "subtotal",
          title: "Subtotal",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
        },
      ],
      fields2: [
        {
          name: "servicio.nombre_servicio",
          sortField: "servicio.nombre_servicio",
          title: "Nombre",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "servicio.descripcion_servicio",
          sortField: "servicio.descripcion_servicio",
          title: "Descripción",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "cantidad_servicios",
          sortField: "cantidad_servicios",
          title: "Cantidad",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "precio_servicio",
          sortField: "precio_cservicio",
          title: "Precio",
          titleClass: "",
          dataClass: "list-item-heading",
        },

        {
          name: "subtotal",
          sortField: "subtotal",
          title: "Subtotal",
          titleClass: "",
          dataClass: "list-item-heading",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Venta",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false,
      showModalE: false, 
      showModalN: false,
      showModalD: false, 
      showModalA: false, 
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
   
    this.detalle();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      console.log(this.$route.params.state);


      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "ventas/view_venta?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          console.log("response", response);
          me.detalleProducto = response.data.orden.detalle_ventas;
          me.detalleServicio = response.data.orden.detalle_servicio_vs;
          me.formPro.usuario = response.data.orden.user.empleado.persona.nombre_persona+' '+response.data.orden.user.empleado.persona.apellido_persona;
          me.formPro.sucursal = response.data.orden.tienda.nombre_tienda;
          //  console.log(this.detalleServicio);
          me.formPro.cliente =
            response.data.orden.cliente.persona.nombre_persona;
          me.formPro.no_ducumento_v = response.data.orden.no_ducumento_v;
          me.formPro.observaciones = response.data.orden.observaciones;
          me.formPro.fecha_venta = response.data.orden.fecha_venta;
          me.formPro.total_v = response.data.orden.total_v;
          me.formPro.estado_credito_v = response.data.orden.estado_credito_v;
          me.formPro.estado_pagado_v  = response.data.orden.estado_pagado_v;
          // me.formPro.direccionp = "Guatemala";
          me.formPro.state = response.data.orden.estado_venta;
          me.formPro.metodos = response.data.orden.credito_ventas;
          // me.formPro.saldo = parseFloat(response.data.orden.pago_cuenta);
          // me.formPro.estado_saldo = response.data.orden.estado_cuenta;
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->
            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div class="text-center">
                    <div class="mb-4"></div>

                    <h4>INFORMACIÓN DE LA VENTA</h4>
                    <br />
                    <router-link
                      :to="{
                        name: 'ventas',
                      }"
                    >
                      <b-button
                        variant="outline-primary"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                        <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                          >REGRESAR</b
                        >
                      </b-button>
                    </router-link>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col" align="center">
                      Fecha de venta:
                      <a href="#" class="badge bg-dark font-size-12">
                        {{ showDate(formPro.fecha_venta) }}
                      </a>
                    </div>
                  </div>
                  <br />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2">Usuario a cargo</p>
                          <h5 class="font-size-15">{{ formPro.usuario }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2">Sucursal</p>
                          <h5 class="font-size-15">
                            {{
                              formPro.sucursal
                            }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Credito</p>
                          <h5 v-if="formPro.estado_credito_v == true && formPro.estado_pagado_v == true">
                            <span class="badge bg-success ms-1"
                            ><strong>PAGADO</strong></span
                            >
                          </h5>
                          <h5  v-else-if="formPro.estado_credito_v == true && formPro.estado_pagado_v == false">
                            <span class="badge bg-danger ms-1"
                              ><strong>PENDIENTE</strong></span
                            >
                          </h5>
                          <h5 v-else-if="formPro.estado_credito_v == false">
                            <span class="badge bg-success ms-1"
                            ><strong>No Crédito</strong></span
                            >
                          </h5>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col">
                        <div>
                          <p class="text-muted mb-2">Cliente</p>
                          <h5 class="font-size-15">
                            {{
                              formPro.cliente != null
                                ? formPro.cliente
                                : "Sin cliente asignado"
                            }}
                          </h5>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">No. Venta</p>
                          <h5 class="font-size-15">{{ formPro.no_ducumento_v }}</h5>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Total</p>
                          <h5 class="font-size-15">
                            {{
                              money(formPro.total_v )
                            }}
                          </h5>
                        </div>
                      </div>
                      <div class="col" v-if="formPro.estado_saldo">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Saldo usado</p>
                          <h5 class="font-size-15">
                            {{ money(formPro.saldo) }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="card" v-if="formPro.estado_credito_v == true">
          <h4 class="card-title">Listado de métodos de pago</h4>
          <br />
          <div class="row">
            <div
              class="col-md-3"
              v-for="(metodo, index) in formPro.metodos"
              v-bind:key="index"
            >
              <b-card bg-variant="secondary">
                <h5 align="center" class="text-white">
                  {{ metodo.metodo_pago }}
                </h5>
                <h2
                  class="text-white"
                  v-if="metodo.metodo_pago == 'Efectivo'"
                  align="center"
                >
                  {{ money(metodo.abono) }}
                </h2>
                <h2
                  class="text-white"
                  v-if="metodo.metodo_pago == 'Transferencia'"
                  align="center"
                >
                  <h5 class="text-white">
                    {{ metodo.numero_pago }}
                  </h5>
                  {{ money(metodo.abono) }}
                  <br />
                </h2>
                <h2
                  class="text-white"
                  v-if="metodo.metodo_pago == 'Deposito'"
                  align="center"
                >
                  <h5 class="text-white">
                    {{ metodo.numero_pago }}
                  </h5>
                  {{ money(metodo.abono) }}
                  <br />
                </h2>
                <h2
                  class="text-white"
                  v-if="metodo.metodo_pago == 'Cheque'"
                  align="center"
                >
                  <h5 class="text-white">
                    {{ metodo.numero_pago }}
                  </h5>
                  {{ money(metodo.abono) }}
                  <br />
                </h2>
                <h2
                  class="text-white"
                  v-if="metodo.metodo_pago == 'Tarjeta'"
                  align="center"
                >
                  <h5 class="text-white">
                    {{ metodo.numero_pago }}
                  </h5>
                  {{ money(metodo.abono) }}
                  <br />
                </h2>
              </b-card>
            </div>
          </div>
        </div> -->

        <div class="card" v-if="detalleProducto.length > 0">
          <div class="card-body">
            <h4 class="card-title">Listado de productos</h4>
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <div class="d-none d-lg-block">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleProducto"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_detalle == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="subtotal" slot-scope="props">
                  {{ money(props.rowData.subtotal_venta) }}
                </div>
                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.precio_venta) }}
                </div>
              </vuetable>
              </div>
              <ResponsiveCards :items="detalleProducto">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.estado_detalle" class="badge bg-success">ACTIVO</span>
                    <span v-else class="badge bg-danger">INACTIVO</span>
                    <span class="rwd-card__value">{{ money(item.subtotal_venta) }}</span>
                  </div>
                  <div class="rwd-card__title">
                    {{ item.producto ? item.producto.nombre_producto : '' }}
                  </div>
                  <div class="rwd-card__sub">
                    {{ item.producto ? item.producto.codigo_stock : '' }}
                  </div>
                  <div class="rwd-card__kv"><span>Marca</span><span>{{ item.producto && item.producto.marca ? item.producto.marca.nombre_marca : '' }}</span></div>
                  <div class="rwd-card__kv"><span>Cantidad</span><span>{{ item.cantidad_venta }}</span></div>
                  <div class="rwd-card__kv"><span>Precio venta</span><span>{{ money(item.precio_venta) }}</span></div>
                </template>
              </ResponsiveCards>
            </Loader>
          </div>
        </div>
        <div class="card" v-if="detalleServicio.length > 0">
          <div class="card-body">
            <h4 class="card-title">Listado de servicios</h4>
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <div class="d-none d-lg-block">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields2"
                :data="detalleServicio"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_detalle == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="subtotal" slot-scope="props">
                  {{ money(props.rowData.subtotal_servicio) }}
                </div>
                <div slot="precio_servicio" slot-scope="props">
                  {{ money(props.rowData.precio_servicio) }}
                </div>
              </vuetable>
              </div>
              <ResponsiveCards :items="detalleServicio">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.estado_detalle" class="badge bg-success">ACTIVO</span>
                    <span v-else class="badge bg-danger">INACTIVO</span>
                    <span class="rwd-card__value">{{ money(item.subtotal_servicio) }}</span>
                  </div>
                  <div class="rwd-card__title">
                    {{ item.servicio ? item.servicio.nombre_servicio : '' }}
                  </div>
                  <div class="rwd-card__sub">
                    {{ item.servicio ? item.servicio.descripcion_servicio : '' }}
                  </div>
                  <div class="rwd-card__kv"><span>Cantidad</span><span>{{ item.cantidad_servicios }}</span></div>
                  <div class="rwd-card__kv"><span>Precio</span><span>{{ money(item.precio_servicio) }}</span></div>
                </template>
              </ResponsiveCards>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
